import React, { useState } from 'react'
import { Box, Tabs, Tab, useTheme, useMediaQuery } from '@mui/material'
import { Email, Description, History } from '@mui/icons-material'
import EmailComposer from '../email/EmailComposer'
import EmailTemplatesTable from '../email/EmailTemplatesTable'
import EmailHistoryTable from '../email/EmailHistoryTable'

const EmailTab = ({ showNotification, onComposeDraftDirtyChange }) => {
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'))
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const [subTabValue, setSubTabValue] = useState(0)
  const [composeTemplateRequest, setComposeTemplateRequest] = useState(null)

  const handleSubTabChange = (event, newValue) => {
    setSubTabValue(newValue)
  }

  const handleUseTemplate = (template) => {
    if (template?.id == null) return

    setComposeTemplateRequest({
      templateId: template.id,
      requestedAt: Date.now(),
    })
    setSubTabValue(0)
  }

  return (
    <Box>
      <Tabs
        value={subTabValue}
        onChange={handleSubTabChange}
        variant={isSmallScreen ? 'scrollable' : 'standard'}
        scrollButtons={isSmallScreen ? 'auto' : false}
        allowScrollButtonsMobile
        sx={{
          borderBottom: 1,
          borderColor: 'divider',
          mb: 3,
          '& .MuiTabs-scroller': {
            overflowX: isSmallScreen ? 'auto !important' : 'hidden',
          },
          '& .MuiTab-root': {
            textTransform: 'none',
            fontSize: { xs: '0.8rem', sm: '0.9rem', md: '1rem' },
            fontWeight: 500,
            minWidth: { xs: 120, sm: 145, md: 0 },
            minHeight: { xs: 72, sm: 76, md: 48 },
            px: { xs: 1.25, sm: 1.75, md: 2 },
            whiteSpace: 'nowrap',
            flexShrink: 0,
          },
          '& .MuiTab-root .MuiSvgIcon-root': {
            fontSize: { xs: '1.15rem', sm: '1.3rem', md: '1.2rem' },
          },
          '& .MuiTab-iconWrapper': {
            marginBottom: { xs: '6px !important', sm: '0 !important', md: '0 !important' },
          },
          '& .MuiTab-root.Mui-selected': {
            color: '#232536',
          },
          '& .MuiTabs-indicator': {
            backgroundColor: '#232536',
          },
          '& .MuiTabs-scrollButtons': {
            color: '#232536',
            '&.Mui-disabled': {
              opacity: 0.3,
            },
          },
        }}
      >
        <Tab
          icon={<Email />}
          iconPosition={isMobile ? 'top' : 'start'}
          label='Compose Email'
        />
        <Tab
          icon={<Description />}
          iconPosition={isMobile ? 'top' : 'start'}
          label='Templates'
        />
        <Tab
          icon={<History />}
          iconPosition={isMobile ? 'top' : 'start'}
          label='Email History'
        />
      </Tabs>

      <Box>
        <Box sx={{ display: subTabValue === 0 ? 'block' : 'none' }}>
          <EmailComposer
            showNotification={showNotification}
            onDraftStateChange={onComposeDraftDirtyChange}
            templateSelectionRequest={composeTemplateRequest}
          />
        </Box>
        {subTabValue === 1 && (
          <EmailTemplatesTable
            showNotification={showNotification}
            onUseTemplate={handleUseTemplate}
          />
        )}
        {subTabValue === 2 && (
          <EmailHistoryTable showNotification={showNotification} />
        )}
      </Box>
    </Box>
  )
}

export default EmailTab
